module.exports = __webpack_public_path__ + "img/main_llw.b92d2a16.jpg";